export default __webpack_public_path__ + "static/media/curbside_pl.6b18bd81.svg";